import {takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {tablesAction} from 'utils/tables';

import {adminAction, GetOrganizationsAction} from '../action';

const tableId = 'organizations';

function* execute({payload: {tableDataRequest, userProfileId}}: GetOrganizationsAction): SagaIterator {
    yield* put(tablesAction.getTableData({
        tableDataRequest,
        apiRequest: Api.getUserOrganizationPage,
        successAction: adminAction.getOrganizationsSuccess,
        tableId,
        pathParams: {
            userProfileId,
        },
    }));
}
/** Runs the admin saga that loads the organizations list for the admin screen. */
export function* getOrganizationsSaga(): SagaIterator {
    yield takeLatestF('admin/GET_ORGANIZATIONS', execute);
}
